import React, { useState } from 'react'
import { DiaperBankPublic } from '../../utils/DiaperBankDTO'
import Button from '../form/Button'
import Modal from '../Modal'
import ShareContent from './ShareContent'

export default function Share({ diaperBank, children }: { diaperBank: DiaperBankPublic; children: (onClick: () => void) => JSX.Element }) {
  const [modalOpen, setModalOpen] = useState(false)
  return (
    <>
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} title='Share Your Diaper Fund'>
        <div>
          <ShareContent diaperBank={diaperBank} />
          <div>
            <Button fullWidth outline className='my-4' onClick={() => setModalOpen(false)}>
              Close
            </Button>
          </div>
        </div>
      </Modal>
      {children(() => setModalOpen(true))}
    </>
  )
}
